var _clipPath;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,4.08261,0.337137)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 45.917,
    cy: 49.663,
    r: 29.003,
    style: {
      fill: "var(--primary-green)"
    }
  }), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip1"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 45.917,
    cy: 49.663,
    r: 29.003
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.452511,0,0,0.411664,21.7726,29.9013)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.407,55.747L46.607,79.77L87.308,16.238",
    style: {
      fill: "none",
      stroke: "white",
      strokeWidth: "18.47px"
    }
  }))), /*#__PURE__*/React.createElement("circle", {
    cx: 45.917,
    cy: 49.663,
    r: 29.003,
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: "1.89px"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check-circle.84a05384041b7faad937fa0daf01d20f.svg";
export { ForwardRef as ReactComponent };